<template>
  <div style="padding-right: 30px">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="货源单号">
        <el-input v-model="form.mainOrderNumber" :disabled="true" />
      </el-form-item>
      <el-form-item label="运输单号">
        <el-input v-model="form.orderCode" :disabled="true" />
      </el-form-item>
      <el-form-item label="实际承运人姓名">
        <el-input v-model="form.driverName" :disabled="true" />
      </el-form-item>
      <el-form-item label="实际承运人手机号">
        <el-input v-model="form.driverPhone" :disabled="true" />
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input v-model="form.vehicleName" :disabled="true" />
      </el-form-item>
      <el-form-item label="托运人名称">
        <el-input v-model="form.shipmentName" :disabled="true" />
      </el-form-item>
      <el-form-item label="托运人手机号">
        <el-input v-model="form.shipmentPhone" :disabled="true" />
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address" type="textarea" :disabled="true" />
      </el-form-item>
      <el-form-item label="照片">
        <el-image
          v-for="(item, k) in form.abnormalImages"
          :key="'zhaopian' + k"
          style="width: 100%"
          :src="item"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="投诉类型">
        <el-input
          v-model="form.abnormalTypeName"
          type="textarea"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="投诉说明">
        <el-input
          v-model="form.abnormalRemark"
          type="textarea"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="发生时间">
        <el-input
          v-model="form.occurrenceTime"
          type="textarea"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="处理结果" prop="handleIdea">
        <el-input
          v-model="form.handleIdea"
          type="textarea"
          maxlength="255"
          placeholder="请输入处理结果"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="funcSubmit">
          立即处理
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { handleAbnormal } from "@/api/transport";
import request from "@/utils/request";

export default {
  name: "Edit",
  data() {
    return {
      form: {},
      rules: {
        handleIdea: [
          { required: true, message: "请填写处理结果", trigger: "blur" },
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getInfo(code) {
      request({
        url: `/ntocc-basic-api/orderDetailAbnormal/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
        const abnormalImage = this.form.abnormalImage;
        if (abnormalImage) {
          this.form.abnormalImages = abnormalImage.split(",");
        }
      });
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          handleAbnormal(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel");
          });
        }
      });
    }
  }
};
</script>
